import { IconBaseProps, IconType } from "@/types/icon";

export const EllipseIcon: IconType = ({
  size = 24,
  color = "text-gray-800",
  ...props
}: IconBaseProps) => {
  return (
    <svg
      className={`${color}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="2"
      height="2"
      fill="none"
      viewBox="0 0 2 2"
      {...props}
    >
      <circle cx="1" cy="1" r="1" fill="#E21D12" />
    </svg>
  );
};
